import * as React from 'react';
import { Link } from 'react-router-dom';
import { ROUTE_PATH } from '../../constants';
import Icon from '../../widgets/Icons';
import ScoreBar from '../../widgets/ScoreBar';
import ScorePanel from '../../widgets/ScorePanel';
import LoadingIndicator from '../../widgets/LoadingIndicator';

type Props = {
  sensorsWorking: number;
  sensorsTotal: number;
  hasSensors: boolean;
  hasScanners: boolean;
  isLoading: boolean;
};

export default class SensorScore extends React.Component<Props> {
  render() {
    const { sensorsWorking, sensorsTotal, hasScanners, hasSensors, isLoading } =
      this.props;
    let label = 'sensors',
      title = 'Sensor';
    if (hasScanners && hasSensors) {
      label = 'sensors or scanners';
      title = 'Sensor & Scanner';
    } else if (hasScanners && !hasSensors) {
      label = 'scanners';
      title = 'Scanner';
    }

    let workingText;
    if (sensorsWorking === sensorsTotal) {
      workingText = `All of your ${label} are fully operational.`;
    } else if (sensorsWorking > 0) {
      workingText = `Some of your ${label} are experiencing problems.`;
    } else {
      workingText = `None of your ${label} are operational.`;
    }

    return (
      <Link
        to={ROUTE_PATH.DASHBOARD.SENSORS}
        className="clickable-dashboard-item"
      >
        <ScorePanel
          className="hover-shadow"
          title={`${title} Status`}
          icon={
            <div className="physical-and-cloud-sensor-icon">
              <Icon.Hdd />
            </div>
          }
          score={
            <div className="score-bar">
              {isLoading ? (
                <LoadingIndicator size="lg" />
              ) : (
                <h1>{`${sensorsWorking} of ${sensorsTotal}`}</h1>
              )}
            </div>
          }
        >
          <ScoreBar
            value={isLoading ? 0 : sensorsWorking}
            max={isLoading ? 100 : sensorsTotal}
          />
          <span>{isLoading ? 'Retrieving status...' : workingText}</span>
        </ScorePanel>
      </Link>
    );
  }
}
